module.exports = __webpack_public_path__ + "img/icon_NZDUSD.4980ff17.png";